<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ (currentPage - 1) * perPage + row.index + 1 }}
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Visualizza Configurazione" variant="outline-secondary" @click="onClickViewConfigurazioneMultiploArticolo(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Modifica Configurazione" variant="outline-success" @click="onClickEditConfigurazioneMultiploArticolo(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella Configurazione" variant="outline-danger" @click="onClickDeleteConfigurazioneCategoriaArticolo(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>

                <configurazioni-magazzino-articoli-multiplo-modal-edit-component ref="cmpConfigurazioniMagazzinoArticoliMultiploModalEdit" @saveMultiploArticolo="loadDataMultiploArticoli" @multiploArticoloDelete="loadDataMultiploArticoli" @onCloseModal="loadDataMultiploArticoli" />
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ConfigurazioniMagazzinoArticoliMultiploModalEditComponent from "./ConfigurazioniMagazzinoArticoliMultiploModalEditComponent.vue";
export default {
    components: { ConfigurazioniMagazzinoArticoliMultiploModalEditComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            id: null,
            currentPage: 1,
            pathResource: "/magazzinoarticolimultipli",
            showModalLoading: false,
            listKey: 0,
            items: [],
            filtroConfigurazioniMultiploArticoli: { codiceAzienda: null, multiploMultiplo: null, descrizioneMultiplo: null },
            fields: [
                {
                    label: "*",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 1rem",
                },
                {
                    label: "Codice Azienda",
                    key: "codiceAzienda",
                    sortable: false,
                },
                {
                    label: "Multiplo",
                    key: "multiploMultiplo",
                    sortable: false,
                },
                {
                    label: "Descrizione multiplo",
                    key: "descrizioneMultiplo",
                    sortable: false,
                },
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadDataMultiploArticoli();
        },
    },
    methods: {
        loadDataMultiploArticoli() {
            let me = this;
            // console.log("ENTRO NEL LOAD DI MULTIPLO ARTICOLI");
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroMultiploArticolo"]) {
                me.filtroConfigurazioniMultiploArticoli = JSON.parse(sessionStorage["filtroMultiploArticolo"]);
                me.$emit("updateFilter", me.filtroConfigurazioniMultiploArticoli);
            }
            me.filtroConfigurazioniMultiploArticoli.page = me.currentPage;
            me.filtroConfigurazioniMultiploArticoli.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroConfigurazioniMultiploArticoli, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
        },
        onClickViewConfigurazioneMultiploArticolo(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMultiploModalEdit.show(item, true);
        },
        onClickEditConfigurazioneMultiploArticolo(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMultiploModalEdit.show(item, false);
        },
        onNuovoMultiploArticolo() {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMultiploModalEdit.show(
                {
                    id: null,
                    codiceAzienda: null,
                    multiploMultiplo: null,
                    descrizioneMultiplo: null,
                },
                false
            );
        },
        onClickDeleteConfigurazioneMultiploArticolo(item) {
            let me = this;
            me.$refs.cmpConfigurazioniMagazzinoArticoliMultiploModalEdit.onDeleteMultiploArticolo(item);
        },
    },
};
</script>
